{
  "launching": "جاري تسجيل الدخول...",
  "changeLanguage": "تغيير اللغة",
  "logOut": "تسجيل الخروج",
  "logout": {
    "success": "تم تسجيل الخروج بنجاح"
  },
  "session": {
    "expired": "انتهت الجلسة، يرجى تسجيل الدخول مجددا"
  }
}
